const WebUrlSources = {
    ONLIVE_SITE: 'onlive.site',
    INTEGRATION_DOMAIN_URL: 'integration-domain-url',
    OTHER: 'other'
};

export default WebUrlSources;